import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IndependentContractorAgreementComponent } from './independent-contractor-agreement.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'captain-ica',
        component: IndependentContractorAgreementComponent,
      },
    ]),
  ],
  exports: [RouterModule],
})
export class IndependentContractorAgreementRoutingModule {}
